<template>
    <div
      <table-component v-bind:data="fetchUserData" :show-caption="false" :show-filter="false" :cache-key="1" cache-lifetime="0" ref="table1"  :filter-no-results=no_result()>
         <table-column show="first_name" label="NAME">
            <template slot-scope="row">
             <router-link :to="'/profile/' + row.id">{{row.first_name}} {{row.last_name}}</router-link>
            </template>
          </table-column>
          <table-column show="companyName" :sortable="true" label="ACCOUNT NAME"></table-column>
          <table-column :sortable="false" label="SCHOOL?">
          <template slot-scope="row">
          <i class="fa fa-check custom-tick" v-if="row.schoolFlag"></i>
          <i class="fa fa-close custom-remove" v-else></i>
          </template>
          </table-column>
          <table-column show="roles" :sortable="false" label="ROLE" :formatter="rolesFormatter"></table-column>
          <table-column show="email"  :sortable="true" label="EMAIL">
          <template slot-scope="row">
           <router-link :to="'/profile/' + row.id">{{row.email}}</router-link>
          </template>
          </table-column>
          <table-column :sortable="false" label="ACTIVATED?">
          <template slot-scope="row">
          <i class="fa fa-check custom-tick" v-if="row.enabled"></i>
          <i class="fa fa-close custom-remove" v-else></i>
          </template>
          </table-column>
          <table-column show="signin_count" :sortable="false" label="SESSION COUNT"></table-column>
          <table-column show="menteeCount" :sortable="false" label="MENTEE COUNT"></table-column>
      </table-component>
    </div>
</template>

<script>
import Vue from 'vue/dist/vue.esm';
import TableComponent1 from 'vue-table-component';
import axios from 'axios';

TableComponent1.settings({
    tableClass: 'table-responsive table table-hover w-100',
    theadClass: '',
    tbodyClass: '',
    filterPlaceholder: 'Filter table…',
});

export default {
      data() {
        return {
          len: '',
        }
      },
      methods: {
        fetchUserData({ page, filter, sort }) {
            return new Promise(resolve => {
                axios.get('/users', { headers: { 'Access-Control-Allow-Origin': '*', 'Accept': 'application/json', 'Content-Type': 'application/json' }, params: {  _sort: sort, _page: page } })
                .then(response => {
                    resolve({
                      data: response.data.data,
                      pagination: {
                        totalPages: response.data.total_pages,
                        currentPage: response.data.page,
                      },
                    });
                    this.len = response.data.data.length;
                  }
                );
            })
        },
        rolesFormatter(value, rowProperties) {
            var roleString = `${value}`;
            let formattedRoles = roleString.replace(new RegExp('ROLE_', 'g'),'');
            formattedRoles =  formattedRoles.replace(new RegExp('_', 'g'),' ');
            return formattedRoles.toLowerCase();
        },
        no_result: function() {
          if(this.len === '') {
              return "Loading...";
          }
          if(this.len === 0) {
              return "No mentors found.";
          }
        }
      },
    }
</script>



// WEBPACK FOOTER //
// src/components/admin/userlists.vue